var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.on_click}},[(_vm.count > 0)?_c('vrecursive-block',{attrs:{"count":_vm.count - 1,"current_index":_vm.current_index,"handle_click":_vm.handle_click}},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.count === 0)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }